import type { ComponentType } from 'react';
import { AuditLogPage } from './AuditLogPage';
import { MemberPermissionsPage } from './MemberPermissionsPage';
import { OrganizationMembersPage } from './OrganizationMembersPage';
import { OrganizationProfilePage } from './OrganizationProfilePage';

/**
 * ORGANIZASYON EKRANLARININ KAYDI.
 *
 * Router'a DOKUNULMAZ: `src/app/screens.ts` bu iki sabiti icine alir
 * (`...organizationScreens`, `exchange: [...organizationExtraRoutes.exchange]`).
 * Boylece feature'i hayata gecirmek rota agacini degistirmeden mumkun oluyor
 * ve birbirinden bagimsiz feature'lar tek bir dosyada catismiyor.
 *
 * Anahtarlar `src/layout/menus.ts` icindeki MENU KIMLIKLERI. Yeni bir kimlik
 * uydurulamaz: menude olmayan bir kimlik hicbir zaman cizilmez.
 */
/**
 * AYNI BILESENLER IKI BOLGEDE (accounts/screens.ts ile ayni desen ve ayni gerekce).
 *
 * Musteri organizasyonu 2026-08-30'da geldi ve ekranlarin isi degismedi: isletme profili,
 * ekip listesi ve denetim kaydi her iki org tipinde de ayni. Ikinci bir kopya, birinde
 * duzeltilen bir hatanin otekinde yasamasi demekti. Tipe gore degisen KUCUK parcalar
 * (yetki grant'lari, oda/sicil alanlari) bilesenin ICINDE `orgTypeCode` ile ayriliyor.
 *
 * Menude `adminOnly` her iki bolgede de isaretli — kapi RequireOrgAdmin, bolgeden bagimsiz.
 */
export const organizationScreens = {
  'exchange.organization': OrganizationProfilePage,
  'exchange.members': OrganizationMembersPage,
  'exchange.auditLog': AuditLogPage,
  'customer.organization': OrganizationProfilePage,
  'customer.members': OrganizationMembersPage,
  'customer.auditLog': AuditLogPage,
} as const satisfies Readonly<Record<string, ComponentType>>;

/**
 * MENUDE GORUNMEYEN rotalar. Bolge guard'ini gruptan miras alirlar; buradaki
 * `adminOnly`, router'da RequireOrgAdmin ret paneline cevriliyor.
 *
 * Yetki duzenleyici menude YER ALMAZ: bir uye secilmeden anlamsiz. Giris
 * noktasi ekip listesindeki satirdir.
 *
 * MUSTERI BOLGESINE KARSILIGI EKLENMEDI: grant edilebilir yetkiler buro ici operasyon
 * yetkileridir (teklif verme, islem tamamlama...). Musteri org'unda personelin tek yetkisi
 * sunucunun varsayilan olarak verdigi `viewAccounts`; duzenlenecek bir kume yok. Ekip
 * ekranindaki "Yetkiler" baglantisi da bu yuzden yalniz buro tipinde ciziliyor.
 */
export const organizationExtraRoutes = {
  exchange: [
    {
      path: '/buro/ekip/:memberId/yetkiler',
      component: MemberPermissionsPage,
      adminOnly: true,
    },
  ],
} as const;
